import { useAccount } from "@azure/msal-react";
import { useUser } from "src/hooks/useUser";

export const useAdmin = () => {
    const account = useAccount();
    if (!account?.idTokenClaims?.groups) return false;
    //@ts-expect-error TODO This is a temporary fix to enforce TS typing.
    return account.idTokenClaims.groups.includes(import.meta.env.VITE_AD_ADMIN_GROUP);
};

export const useNotAuthorizedUser = () => {
    const account = useAccount();
    const { data: user, isLoading } = useUser();
    const isAdmin = useAdmin();

    if (!account) return null;

    // If user data is still loading, don't show unauthorized yet
    if (isLoading) return false;

    if (isAdmin) {
        return false; // Admin users are always authorized
    }

    // If we have user data, check if user has any accessible datasources
    if (user) {
        const hasAccessibleDatasources = user.datasources?.some((ds) => ds.has_access);
        // User is unauthorized if they have no accessible datasources
        if (!hasAccessibleDatasources) {
            return true;
        }
    }

    return false;
};
